// Проекты и недавние результаты. Экраны 02 и 09.

import type { UnitId } from '@smyslika/core'

import type { Client } from './client.ts'

export interface Project {
  id: string
  title: string
  topic?: string
  createdAt: string
  /** Сколько чатов в проекте — карточка на экране 09. */
  chats: number
  /** Сколько результатов и каких единиц. Пусто — в проекте пока пусто. */
  results: Partial<Record<UnitId, number>>
  /** Последнее движение: «вчера», «2 дня назад», «сегодня». */
  lastActiveAt?: string
}

/**
 * Строка блока «Недавние результаты» и таблицы истории.
 *
 * Заголовок выводит СЕРВЕР из нагрузки артефакта — там, где нагрузка и лежит.
 * Клиенту она целиком не приезжает, и собирать имя ему было бы не из чего;
 * хранить же заголовок отдельным полем нельзя — он разойдётся с содержимым
 * после первой бесплатной правки. Пусто — строку называет сценарий, а не
 * выдуманное имя.
 */
export interface RecentResult {
  runId: string
  /** Чат, в котором результат лежит. Строка истории ведёт туда, а не на экран. */
  chatId?: string
  artifactId?: string
  type?: string
  title?: string
  unit: string
  scenario: string
  project?: { id: string; title: string }
  finishedAt?: string
}

export interface Workspace {
  projects: Project[]
  recent: RecentResult[]
}

export const createProjects = (client: Client) => ({
  workspace: () => client.request<Workspace>('/v1/projects'),
  create: (title: string, topic?: string) =>
    client.request<Project>('/v1/projects', {
      method: 'POST',
      body: { title, ...(topic != null && topic !== '' ? { topic } : {}) },
    }),
})

export type Projects = ReturnType<typeof createProjects>
